export default function IconUserCircle({ solid = false }: { solid?: boolean }) {
	if (solid) {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" id="User-Circle-Single--Streamline-Core" height="20" width="20">
				<g id="user-circle-single--circle-geometric-human-person-single-user">
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M20 10c0 2.6812428571428573 -1.0552857142857144 5.116 -2.773 6.911714285714285 -1.8142857142857143 1.8964285714285714 -4.367428571428571 3.08 -7.197157142857143 3.088285714285714L10 20l-0.029842857142857143 0c-2.8297285714285714 -0.008285714285714285 -5.382928571428572 -1.191857142857143 -7.197114285714286 -3.088285714285714C1.055227142857143 15.116000000000001 0 12.681242857142857 0 10c0 -5.522842857142857 4.477157142857143 -10 10 -10 5.522857142857143 0 10 4.477157142857143 10 10Zm-3.938857142857143 5C14.620142857142858 13.254957142857144 12.439914285714288 12.142814285714286 10 12.142814285714286c-2.439914285714286 0 -4.620085714285715 1.112142857142857 -6.061214285714286 2.8571857142857144 1.4411285714285715 1.745 3.6213 2.857142857142857 6.061214285714286 2.857142857142857 2.439914285714286 0 4.6201428571428576 -1.112142857142857 6.061142857142857 -2.857142857142857ZM10.000171428571429 10.714242857142859c1.9724428571428574 0 3.5714285714285716 -1.5989857142857142 3.5714285714285716 -3.5714285714285716s-1.5989857142857142 -3.5714285714285716 -3.5714285714285716 -3.5714285714285716 -3.5714285714285716 1.5989857142857142 -3.5714285714285716 3.5714285714285716 1.5989857142857142 3.5714285714285716 3.5714285714285716 3.5714285714285716Z"
						clipRule="evenodd"
						strokeWidth="1.4286"
					></path>
				</g>
			</svg>
		);
	}

	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.715 -0.715 20 20" id="User-Circle-Single--Streamline-Core" height="20" width="20">
			<g id="user-circle-single--circle-geometric-human-person-single-user">
				<path
					id="Vector"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M9.285 10.611428571428572c1.831413192857143 0 3.316071428571429 -1.4846582357142857 3.316071428571429 -3.316071428571429S11.116413192857145 3.9792857142857145 9.285 3.9792857142857145 5.968928571428572 5.463943950000001 5.968928571428572 7.295357142857143 7.453586807142858 10.611428571428572 9.285 10.611428571428572Z"
					strokeWidth="1.43"
				></path>
				<path
					id="Vector_2"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M3.6211234714285716 15.784500000000001c0.5919054857142858 -0.9716089285714287 1.4238016928571429 -1.774628785714286 2.4157049785714286 -2.331728785714286 0.9919032857142858 -0.5572591714285715 2.1104539714285715 -0.8499223714285715 3.2481450214285714 -0.8499223714285715 1.13769105 0 2.2562417357142857 0.2926632 3.2481450214285714 0.8499223714285715 0.9919430785714286 0.5571 1.8237464357142859 1.3601198571428574 2.415731507142857 2.331728785714286"
					strokeWidth="1.43"
				></path>
				<path
					id="Vector_3"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M9.285 17.906785714285714c4.761745928571429 0 8.621785714285714 -3.8600397857142856 8.621785714285714 -8.621785714285714C17.906785714285714 4.523320392857143 14.04674592857143 0.6632142857142858 9.285 0.6632142857142858 4.523320392857143 0.6632142857142858 0.6632142857142858 4.523320392857143 0.6632142857142858 9.285c0 4.761745928571429 3.8601061071428573 8.621785714285714 8.621785714285714 8.621785714285714Z"
					strokeWidth="1.43"
				></path>
			</g>
		</svg>
	);
}
